import { render, staticRenderFns } from "./ListSuggest.vue?vue&type=template&id=0c38f1f0"
import script from "./ListSuggest.vue?vue&type=script&lang=js"
export * from "./ListSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports